import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ControlContainer, FormGroup, FormControl, NgControlStatus, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import { FromPicklistPipe } from 'src/app/shared/pipes/fromPicklistPipe.pipe';
import { ToPicklistPipe } from 'src/app/shared/pipes/toPicklistPipe.pipe';

import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { GridTableParametersService } from 'src/app/template/gridTemplate/gridTableParameters.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { AuthentService } from 'src/app/Services/authent.service';


declare const errorKeys: any;

var MY_FORMATS = {
  parse: {
    dateInput: '',
  },
  display: {
    dateInput: "",
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-formular',
  templateUrl: './formularTemplate.component.html',
  styleUrls: ['./formularTemplate.component.css'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class FormularComponent implements OnInit {
  @Input() public formBuilderInput;
  @Input() public formular;
  @Input() public passwordMinNonAlphanumericCharacters;
  @Input() public passwordMinUniqueChars;
  @Input() public groupName;
  @Output() public action = new EventEmitter();
  @Output() public date = new EventEmitter();
  @Output() public file = new EventEmitter();

  resourceDefinition;
  Picklist;
  PicklistWithoutUnused = {};

  constructor(
    private parentFormControl: ControlContainer,
    private shareData: SharingDataService,
    public fromPicklist: FromPicklistPipe,
    public toPicklist: ToPicklistPipe,
    public grid: GridTableParametersService,
    public datepipe: DatePipe,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
    private errorHandlingService: ErrorHandlingService,
    public datePipe: DatePipe,
    public dateAdapter: DateAdapter<any>,
    private authentService: AuthentService
  ) { }

  @ViewChild('fileInput') fileName;

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentPicklist.subscribe(data => {
      this.Picklist = data;
      for(let picklistElement in this.Picklist){
        this.PicklistWithoutUnused[picklistElement] = new Array();
        for(let i = 0; i < this.Picklist[picklistElement].length; i++){
          if(this.Picklist[picklistElement][i]?.unused == 0 || this.Picklist[picklistElement][i]?.unused == undefined){
            this.PicklistWithoutUnused[picklistElement].push(this.Picklist[picklistElement][i]);
          }
        }
      }
    });
    this.shareData.currentLanguage.subscribe(data => {
      if(this.authentService.isLoggedIn()) this.dateAdapter.setLocale(data);
    });
    for(let element in this.formBuilderInput.value) {
      let format = this.translateResourceDefinition.transform(element, this.resourceDefinition, 'KEY_NAME', 'FORMAT', this.groupName);
      if(format != null && format != element){
        MY_FORMATS.display.dateInput = MY_FORMATS.parse.dateInput = format.toUpperCase();
      }
    }
  }

  dateChange(event: any) {
    this.date.emit(event);
  }

  onSubmit(action: string) {
    this.action.emit(action)
  }

  fileToUpload: File = null;
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.file.emit(this.fileToUpload);
  }

  onInput(){
    let filename = this.fileName.nativeElement.files[0].name;
    if (filename != undefined)  {
      let fileHasBeenSelected = this.translateResourceDefinition.transform("fileHasBeenSelected", this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', "Common");
      fileHasBeenSelected = fileHasBeenSelected.replace("{0}",filename);
      
      this.errorHandlingService.showInfo('', fileHasBeenSelected)
    }
  }

  validatorRequired(name){
    return `${this.translateResourceDefinition.transform(name, this.resourceDefinition, "KEY_NAME", "LONG_TEXT", this.groupName)} ${this.translateResourceDefinition.transform("isRequired", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", this.groupName)}`
  }

  autocompleteError(value){
    return `${value} ${this.translateResourceDefinition.transform("NotFound", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", this.groupName)}`
  }

  validator(text, name, value){
    text = this.translateResourceDefinition.transform(text, this.resourceDefinition, "KEY_NAME", "LONG_TEXT", this.groupName);
    name = this.translateResourceDefinition.transform(name, this.resourceDefinition, "KEY_NAME", "LONG_TEXT", this.groupName);
    var result = text.replace("{0}", name);
    result = result.replace("{1}", value);
    return result;
  }

  changeDate(value){
    console.log(value)
    let date = new Date(value.value);
    var dateValue = this.datePipe.transform(date, "yyyy-MM-ddTHH:mm:ssZ").substring(0,22) + ":" + this.datePipe.transform(date, "yyyy-MM-ddTHH:mm:ssZ").substring(22);
    let object = {
      value: dateValue,
      type: value.targetElement.name,
    }
    this.dateChange(object)
  }
}
